module.exports = __webpack_public_path__ + "img/mortgage.b7ce913a.svg";